import { Box } from '@zillow/constellation-10';
import ChatAvatar from '../../ChatAvatar';
import ChatBubbleWithLinkFeatureToggle from '../../ChatBubbleWithLinkFeatureToggle';
import MessageFooter from '../../MessageFooter';
import { MessageMetaLabelVariant } from '../../MessageFooter/MessageMetaLabel';

type AutoResponseMessageProps = {
  message: string;
  messageDateMs: string;
  metaLabelType?: MessageMetaLabelVariant;
  enableClickableLinks?: boolean;
};

export default function AutoResponseMessage({
  message,
  messageDateMs,
  metaLabelType = 'eliseAI',
  enableClickableLinks = false,
}: AutoResponseMessageProps) {
  if (!message) {
    return null;
  }

  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
      }}
    >
      <ChatAvatar type="bot" />

      <Box css={{ display: 'flex', flexDirection: 'column', flex: '1', width: '100%' }}>
        <ChatBubbleWithLinkFeatureToggle variant="autoResponse" enableClickableLinks={enableClickableLinks}>
          {message}
        </ChatBubbleWithLinkFeatureToggle>

        <MessageFooter isMessageOwner={false} metaLabelType={metaLabelType} messageDateMs={messageDateMs} />
      </Box>
    </Box>
  );
}
